import { AnalyticsProvider } from '@repo/analytics';
import AuthProvider from '@repo/auth/provider';
import type { ThemeProviderProps } from 'next-themes';
import { Toaster } from './components/ui/sonner';
import { TooltipProvider } from './components/ui/tooltip';
import { ThemeProvider } from './providers/theme';

// Export advanced date filter components and utilities
export { AdvancedDateFilter } from './components/ui/advanced-date-filter';
export type {
  AdvancedDateFilter as AdvancedDateFilterType,
  DateFilterOperator,
} from './components/ui/advanced-date-filter';
export { convertAdvancedDateFilterToBackend } from './lib/date-filter-utils';
export type { DateRangeFilter } from './lib/date-filter-utils';

type DesignSystemProviderProperties = ThemeProviderProps;

export const DesignSystemProvider = ({
  children,
  ...properties
}: DesignSystemProviderProperties) => (
  <ThemeProvider {...properties}>
    <AuthProvider>
      <AnalyticsProvider>
        <TooltipProvider>{children}</TooltipProvider>
        <Toaster />
      </AnalyticsProvider>
    </AuthProvider>
  </ThemeProvider>
);
